import React, { ReactNode } from 'react';
import { clsx } from '../../utils/utils';

import * as styles from './Button.module.scss';

export interface ButtonProps extends Omit<React.HTMLAttributes<HTMLElement>, 'children'> {
  children: string | ReactNode;
  outlined?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  type?: 'submit';
  secondary?: boolean;
  className?: string;
}

const Button = ({
  children,
  outlined,
  secondary,
  onClick,
  type,
  className,
  ...restProps
}: ButtonProps): React.ReactElement => {
  return (
    <button
      onClick={onClick}
      className={clsx(
        styles.button,
        outlined && styles.outlined,
        secondary && styles.secondary,
        className,
      )}
      type={type === 'submit' ? 'submit' : 'button'}
      {...restProps}
    >
      {children}
    </button>
  );
};

export default Button;
